module.exports = __webpack_public_path__ + "static/media/plus-circle.7aa54346.svg";